import { sendDwh } from 'reactApp/utils/ga';
import opener from 'reactApp/utils/opener';

import { createBoardUrl } from '../featuresHelpers/features/boardEntryPoints';

export const createBoardClick = () => {
    sendDwh({ eventCategory: 'dropdown-create-board-click' });
    opener(createBoardUrl);
};
